import { useFormContext } from "react-hook-form";
import { useSelector } from "src/redux/hooks";
import { convertFromUUIDKeys } from "src/redux/utils/convertFromUUIDKeys";
import { insertValues } from "src/redux/utils/insertValues";

/**
 * Custom hook to convert logbook entry for saving.
 *
 * @param manualSave - An optional boolean indicating whether the save is manual.
 * @returns A function to convert logbook entry data into a JSON string for saving.
 */
export const useConvertLbEntry = (manualSave: boolean = false) => {
  const { lbentry } = useSelector(state => state.generatorSlice);
  const { getValues } = useFormContext();
  /**
   * Converts logbook entry data into a JSON string.
   *
   * @param data - An optional object containing the logbook entry data to convert.
   * @returns A JSON string representing the converted logbook entry.
   */
  const convertLbEntry = (data?: Record<string, any>) => {
    const values = data ?? getValues();

    const modifiedLogbook = insertValues(values, lbentry.sections, manualSave);
    // console.log("modifiedLogbook", modifiedLogbook);
    const originalLogbookVersion = convertFromUUIDKeys(modifiedLogbook);
    const objToSend = {
      ...lbentry,
      sections: originalLogbookVersion,
    };
    return JSON.stringify(objToSend);
  };

  return convertLbEntry;
};
